// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#laman.layerManagerMain.closed {
  transform: translateX(-100%);
  /* Panelin sola kayarak gizlenmesi */
}

.toggle-button {
  position: fixed;
  /* Butonun ekranda sabit kalmasını sağlar */
  left: calc(375px);
  /* Butonu panelin sağ kenarına yerleştir */
  top: 50%;
  /* Dikey olarak ortala */
  width: 21px;
  height: 40px;
  background-color: #cccccc6e;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 0 20% 20% 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  /* Gölge ekle */
  z-index: 2;
  /* Butonun panelin üzerinde olmasını sağla */
  transition: transform 0.3s ease;
  /* Butonun hareket animasyonu */
}

#laman.layerManagerMain.closed + .toggle-button {
  transform: translateX(-375px);
}

.toggle-button:hover {
  background-color: #bbb;
  /* Butona hover efekti ekle */
}

.arrow {
  rotate: 180deg;
  width: 0;
  height: 0;
  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent;
  border-left: 7px solid #000;
  transition: transform 0.3s ease;
}

.arrow.right {
  transform: rotate(180deg);
  /* Ok işaretini sağa döndür */
}

#calismaListTable.ant-table {
  font-size: 12px;
}

.scale-select {
  position: absolute;
  bottom: 6px;
  right: 10px;
  z-index: 1000;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  background: rgba(255, 255, 255, 0.8);

  .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    height: 30px !important;
    font-size: 12px;
  }
}

#muh-list {
  .ant-card-head {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }

  .ant-card {
    margin-bottom: 0px !important;
  }

  .desc {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.proje-bilgi .ant-form-item-control-input {
  margin-top: 0;
}

.my-custom-modal-class .ant-modal-header {
  border-bottom: none;
}

.my-custom-modal-class .ant-modal-body {
  max-height: calc(100vh - 120px);
  /* Ekran boyuna göre ayarla */
  overflow-y: auto;
  padding-top: 0;
  /* Üstteki padding'i kaldır */
}

#projeListTable.ant-table .ant-table-thead tr th {
  text-wrap: wrap;
}

html,
body {
  margin: 0;
  height: 100%;
}

#scale-value {
  position: absolute;
  bottom: 50px;
  right: 10px;
  background: white;
  padding: 5px;
  font-size: 12px;
}

#map {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  right: 0;
  overflow: hidden;
}

#map2 .ol-viewport {
  min-height: inherit;
}

#map2 {
  position: relative;
  top: 0;
  /* bottom: 0; */
  min-height: 500px;
  height: 100%;
  /* width: 100%; */
}

#map2 .ol-zoom {
  top: 0.5em;
  right: 0.5em;
  left: auto;
}

#map .ol-zoom {
  top: 0.5em;
  right: 0.5em;
  left: auto;
}

#map .ol-scale-bar,
.ol-scale-line {
  left: auto !important;
  right: 0.5em !important;
  transform: translateX(0) !important;
  padding: 2px !important;
  /* bottom: 10px !important; */
}

.ol-scale {
  left: auto !important;
  right: 0.5em;
  transform: none !important;
  /* bottom: 3.5em !important; */

  input {
    width: 84px !important;
    font-size: 11px;
  }
}

#laman.layerManagerMain {
  position: fixed;
  z-index: 1;
  width: 375px;
  display: block;
  top: 0;
  left: 0;
  bottom: 0;
  opacity: 0.8;
  box-shadow: 6px 0 16px -8px rgba(0, 0, 0, 0.08), 9px 0 28px 0 rgba(0, 0, 0, 0.05),
    12px 0 48px 16px rgba(0, 0, 0, 0.03);
  transition: transform 0.3s ease;
  /* Panelin kayarak açılıp kapanması için animasyon */

  .layerManagerCards {
    height: 100%;

    .projectName {
      text-align: justify;
      font-size: 14px;
    }

    .ant-table-pagination.ant-pagination {
      align-items: center;
      justify-content: center;
    }

    .ant-card-head .ant-card-head-title {
      font-weight: 450;
      text-align: center;
    }

    .ant-card-body {
      padding: 0 !important;
      height: 100%;
    }

    .ant-tabs-nav {
      margin: 0;

      .ant-tabs-tab-btn span svg {
        padding-right: 5px;
      }
    }

    .ninjadash-tab-white .ant-tabs-content {
      padding: 0;
    }

    .user-info {
      border-bottom: 1px solid rgb(241, 242, 246);
      padding: 10px;
      margin: 0;

      .buttonArea {
        display: flex;
        gap: 10px;
        justify-content: space-between;
      }

      button {
        flex: 1 1;
      }
    }

    .user-info__title {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .add-work {
        margin-right: 10px;
      }
    }
  }
}

@media (max-width: 767px) {
  /* Mobil panel davranışı */
  #laman.layerManagerMain {
    position: fixed !important;
    bottom: 0;
    left: 0;
    right: 0;
    top: auto !important;
    width: 100% !important;
    height: 75vh !important;
    max-height: 75vh !important;
    z-index: 999;
    background: white;
    transform: translateY(0%);
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.15);
    overflow: hidden;
    transition: transform 0.3s ease;
  }

  #laman.layerManagerMain.closed {
    transform: translateY(100%) !important;
  }

  /* Panel içeriği */
  .layerManagerCards .ant-card-body {
    flex-grow: 1;
    overflow-y: auto;
    padding: 12px;
  }

  .layerManagerTitle {
    font-size: 13px;
    text-align: center;
    padding: 0 12px;
    word-break: break-word;
  }

  .projectName {
    font-size: 12.5px;
    text-align: center;
    color: #666;
    padding: 0 12px;
  }

  .settings-menmulist ul {
    padding: 0;
    margin: 0;
    list-style: none;
  }

  .settings-menmulist ul li a {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    font-size: 14px;
    color: #333;
    border-radius: 6px;
  }

  .settings-menmulist ul li a:hover {
    background: #f5f5f5;
  }

  .settings-menmulist ul li a svg {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
  }

  .settings-menmulist ul li a span {
    word-break: break-word;
  }
}

.table-header-align-center .ant-table-thead > tr > th {
  text-align: center;
}

.ol-popup {
  position: absolute;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #d0d5dd;
  box-shadow: 0 8px 24px rgba(16, 24, 40, 0.12);
  padding: 12px 14px;
  min-width: 260px;
  transform: translate(-50%, -100%);
  pointer-events: auto;
  z-index: 1000;
}
.ol-popup-closer {
  position: absolute;
  top: 6px;
  right: 8px;
  text-decoration: none;
  color: #667085;
  font-size: 18px;
  line-height: 14px;
}
.ol-popup table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}
.ol-popup td {
  padding: 4px 0;
  vertical-align: top;
}
.ol-popup td:first-child {
  font-weight: 600;
  color: #344054;
  width: 38%;
  padding-right: 8px;
}

.ol-tooltip {
  position: absolute;
  background: transparent;
  pointer-events: none;
  z-index: 1000;
  white-space: nowrap;
}

.ant-collapse.calismaCollapse {
  border-radius: 0;

  .ant-collapse-extra {
    height: 23.56px;
    color: dimgrey;
  }

  .genExtra {
    display: flex;
    align-items: center;

    .ant-divider-vertical {
      margin: 0 1px;
    }
  }

  .ant-collapse-content {
    .ant-collapse-content-box {
      padding: 0;
    }
  }

  .ant-collapse-item {
    border-radius: 0;

    .ant-collapse-header {
      padding: 5px 10px;
    }
  }

  .ant-table-thead tr th,
  .ant-table-tbody tr td,
  .ant-table tfoot tr th,
  .ant-table tfoot tr td {
    padding: 2px 10px;
  }
}

.ant-collapse.halihazirCollapse {
  border-radius: 0;

  .ant-collapse-extra {
    height: 23.56px;
    color: dimgrey;
  }

  .genExtra {
    display: flex;
    align-items: center;

    .ant-divider-vertical {
      margin: 0 1px;
    }
  }

  .ant-collapse-content {
    .ant-collapse-content-box {
      padding: 5px;
    }
  }

  .halihazirGroup .ant-collapse-content {
    .ant-collapse-content-box {
      padding: 0px;
    }
  }

  .ant-collapse-item {
    border-radius: 0;

    .ant-collapse-header {
      padding: 5px 10px;
    }
  }

  .ant-table-thead tr th,
  .ant-table-tbody tr td,
  .ant-table tfoot tr th,
  .ant-table tfoot tr td {
    padding: 2px 10px;
  }
}

.projeToolbar {
  position: absolute;
  z-index: 1;
  display: block;
  width: auto;
  top: 23px;
  left: 390px;
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

.ant-card {
  border-radius: 0;
}

.mouse-position {
  position: absolute;
  bottom: 2px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(255, 255, 255, 0.8);
  padding: 5px;
  /* border-radius: 3px; */
  font-size: 12px;
  z-index: 1000;

  @media screen and (max-width: 767px) {
    font-size: 10px;
  }
}

.ant-menu-submenu-popup {
  z-index: 1005 !important;
}

.label-center .ant-form-item-label {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 76px;
}

.input-sm .ant-input-sm {
  padding: 6.5px 20px;
}

.ant-input-number-group-wrapper {
  width: 100%;
}

.mt-24 {
  margin-top: 24px;
}

.center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.layerManagerTitle {
  font-weight: 450;
  text-align: center;
  margin: 0px;
  margin-left: 8px;
  font-size: 18px;
  color: #0a0a0a;
}

.layerManagerHeaderLogo {
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: #fafafa solid 2px;
  padding: 10px 0;
}

.layerManagerHeaderLogoHeader {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  border-bottom: #fafafa solid 2px;
  padding: 10px;
}

.yerbisLogo {
  display: flex;
  justify-content: center;
  margin: 10px 0;
}

@media (max-width: 767px) {
  #laman.layerManagerMain.closed {
    transform: translateY(100%) !important;
  }

  #laman.layerManagerMain {
    position: fixed !important;
    bottom: 0;
    left: 0;
    right: 0;
    top: auto !important;
    width: 100% !important;
    height: 75vh !important;
    max-height: 75vh !important;
    z-index: 999;
    background: white;
    transform: translateY(0%);
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.15);
    overflow: hidden;
    transition: transform 0.3s ease;
    padding-top: 30px;
  }

  .mobile-panel-toggle {
    position: fixed;
    top: 10px;
    left: 50%;
    transform: translateX(-50%);
    width: 40px;
    height: 21px !important;
    background: rgba(200, 200, 200, 0.85);
    border-radius: 0 20% 20% 0;
    z-index: 1001;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
  }

  .mobile-panel-toggle .arrow {
    width: 0;
    height: 0;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-top: 7px solid #000;
    transition: transform 0.3s ease;
  }

  .mobile-panel-toggle .arrow.down {
    transform: rotate(180deg);
  }

  .ql-toolbar.ql-snow .ql-formats button {
    width: 24px !important;
    height: 24px !important;
  }

  .ql-toolbar.ql-snow .ql-formats svg {
    width: 16px !important;
    height: 16px !important;
  }

  .ql-toolbar.ql-snow {
    padding: 4px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/container/afetVeriAnalizi/style.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,2CAA2C;EAC3C,iBAAiB;EACjB,0CAA0C;EAC1C,QAAQ;EACR,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,0BAA0B;EAC1B,yCAAyC;EACzC,eAAe;EACf,UAAU;EACV,4CAA4C;EAC5C,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,oCAAoC;EACpC,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,oCAAoC;;EAEpC;IACE,uBAAuB;IACvB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,4BAA4B;IAC5B,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,gBAAgB;EAChB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,SAAS;EACT,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,UAAU;AACZ;;AAEA;;EAEE,qBAAqB;EACrB,uBAAuB;EACvB,mCAAmC;EACnC,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,0BAA0B;EAC1B,8BAA8B;;EAE9B;IACE,sBAAsB;IACtB,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;EACf,UAAU;EACV,YAAY;EACZ,cAAc;EACd,MAAM;EACN,OAAO;EACP,SAAS;EACT,YAAY;EACZ;wCACsC;EACtC,+BAA+B;EAC/B,oDAAoD;;EAEpD;IACE,YAAY;;IAEZ;MACE,mBAAmB;MACnB,eAAe;IACjB;;IAEA;MACE,mBAAmB;MACnB,uBAAuB;IACzB;;IAEA;MACE,gBAAgB;MAChB,kBAAkB;IACpB;;IAEA;MACE,qBAAqB;MACrB,YAAY;IACd;;IAEA;MACE,SAAS;;MAET;QACE,kBAAkB;MACpB;IACF;;IAEA;MACE,UAAU;IACZ;;IAEA;MACE,2CAA2C;MAC3C,aAAa;MACb,SAAS;;MAET;QACE,aAAa;QACb,SAAS;QACT,8BAA8B;MAChC;;MAEA;QACE,SAAO;MACT;IACF;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,8BAA8B;;MAE9B;QACE,kBAAkB;MACpB;IACF;EACF;AACF;;AAEA;EACE,0BAA0B;EAC1B;IACE,0BAA0B;IAC1B,SAAS;IACT,OAAO;IACP,QAAQ;IACR,oBAAoB;IACpB,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;IAC3B,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;IACzB,4BAA4B;IAC5B,6BAA6B;IAC7B,2CAA2C;IAC3C,gBAAgB;IAChB,+BAA+B;EACjC;;EAEA;IACE,sCAAsC;EACxC;;EAEA,kBAAkB;EAClB;IACE,YAAY;IACZ,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,6CAA6C;EAC7C,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,oBAAoB;EACpB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;;EAEhB;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,mBAAmB;;IAEnB;MACE,aAAa;IACf;EACF;;EAEA;IACE;MACE,UAAU;IACZ;EACF;;EAEA;IACE,gBAAgB;;IAEhB;MACE,iBAAiB;IACnB;EACF;;EAEA;;;;IAIE,iBAAiB;EACnB;AACF;;AAEA;EACE,gBAAgB;;EAEhB;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,mBAAmB;;IAEnB;MACE,aAAa;IACf;EACF;;EAEA;IACE;MACE,YAAY;IACd;EACF;;EAEA;IACE;MACE,YAAY;IACd;EACF;;EAEA;IACE,gBAAgB;;IAEhB;MACE,iBAAiB;IACnB;EACF;;EAEA;;;;IAIE,iBAAiB;EACnB;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,WAAW;EACX,SAAS;EACT,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,2BAA2B;EAC3B,oCAAoC;EACpC,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,aAAa;;EAEb;IACE,eAAe;EACjB;AACF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE;IACE,sCAAsC;EACxC;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,OAAO;IACP,QAAQ;IACR,oBAAoB;IACpB,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;IAC3B,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;IACzB,4BAA4B;IAC5B,6BAA6B;IAC7B,2CAA2C;IAC3C,gBAAgB;IAChB,+BAA+B;IAC/B,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,WAAW;IACX,uBAAuB;IACvB,qCAAqC;IACrC,0BAA0B;IAC1B,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,yCAAyC;EAC3C;;EAEA;IACE,QAAQ;IACR,SAAS;IACT,kCAAkC;IAClC,mCAAmC;IACnC,0BAA0B;IAC1B,+BAA+B;EACjC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;AACF","sourcesContent":["#laman.layerManagerMain.closed {\r\n  transform: translateX(-100%);\r\n  /* Panelin sola kayarak gizlenmesi */\r\n}\r\n\r\n.toggle-button {\r\n  position: fixed;\r\n  /* Butonun ekranda sabit kalmasını sağlar */\r\n  left: calc(375px);\r\n  /* Butonu panelin sağ kenarına yerleştir */\r\n  top: 50%;\r\n  /* Dikey olarak ortala */\r\n  width: 21px;\r\n  height: 40px;\r\n  background-color: #cccccc6e;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  border-radius: 0 20% 20% 0;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\r\n  /* Gölge ekle */\r\n  z-index: 2;\r\n  /* Butonun panelin üzerinde olmasını sağla */\r\n  transition: transform 0.3s ease;\r\n  /* Butonun hareket animasyonu */\r\n}\r\n\r\n#laman.layerManagerMain.closed + .toggle-button {\r\n  transform: translateX(-375px);\r\n}\r\n\r\n.toggle-button:hover {\r\n  background-color: #bbb;\r\n  /* Butona hover efekti ekle */\r\n}\r\n\r\n.arrow {\r\n  rotate: 180deg;\r\n  width: 0;\r\n  height: 0;\r\n  border-top: 7px solid transparent;\r\n  border-bottom: 7px solid transparent;\r\n  border-left: 7px solid #000;\r\n  transition: transform 0.3s ease;\r\n}\r\n\r\n.arrow.right {\r\n  transform: rotate(180deg);\r\n  /* Ok işaretini sağa döndür */\r\n}\r\n\r\n#calismaListTable.ant-table {\r\n  font-size: 12px;\r\n}\r\n\r\n.scale-select {\r\n  position: absolute;\r\n  bottom: 6px;\r\n  right: 10px;\r\n  z-index: 1000;\r\n  border-radius: 4px;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\r\n  background: rgba(255, 255, 255, 0.8);\r\n\r\n  .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {\r\n    height: 30px !important;\r\n    font-size: 12px;\r\n  }\r\n}\r\n\r\n#muh-list {\r\n  .ant-card-head {\r\n    padding-left: 0px !important;\r\n    padding-right: 0px !important;\r\n  }\r\n\r\n  .ant-card {\r\n    margin-bottom: 0px !important;\r\n  }\r\n\r\n  .desc {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n  }\r\n}\r\n\r\n.proje-bilgi .ant-form-item-control-input {\r\n  margin-top: 0;\r\n}\r\n\r\n.my-custom-modal-class .ant-modal-header {\r\n  border-bottom: none;\r\n}\r\n\r\n.my-custom-modal-class .ant-modal-body {\r\n  max-height: calc(100vh - 120px);\r\n  /* Ekran boyuna göre ayarla */\r\n  overflow-y: auto;\r\n  padding-top: 0;\r\n  /* Üstteki padding'i kaldır */\r\n}\r\n\r\n#projeListTable.ant-table .ant-table-thead tr th {\r\n  text-wrap: wrap;\r\n}\r\n\r\nhtml,\r\nbody {\r\n  margin: 0;\r\n  height: 100%;\r\n}\r\n\r\n#scale-value {\r\n  position: absolute;\r\n  bottom: 50px;\r\n  right: 10px;\r\n  background: white;\r\n  padding: 5px;\r\n  font-size: 12px;\r\n}\r\n\r\n#map {\r\n  position: absolute;\r\n  top: 0;\r\n  bottom: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  right: 0;\r\n  overflow: hidden;\r\n}\r\n\r\n#map2 .ol-viewport {\r\n  min-height: inherit;\r\n}\r\n\r\n#map2 {\r\n  position: relative;\r\n  top: 0;\r\n  /* bottom: 0; */\r\n  min-height: 500px;\r\n  height: 100%;\r\n  /* width: 100%; */\r\n}\r\n\r\n#map2 .ol-zoom {\r\n  top: 0.5em;\r\n  right: 0.5em;\r\n  left: auto;\r\n}\r\n\r\n#map .ol-zoom {\r\n  top: 0.5em;\r\n  right: 0.5em;\r\n  left: auto;\r\n}\r\n\r\n#map .ol-scale-bar,\r\n.ol-scale-line {\r\n  left: auto !important;\r\n  right: 0.5em !important;\r\n  transform: translateX(0) !important;\r\n  padding: 2px !important;\r\n  /* bottom: 10px !important; */\r\n}\r\n\r\n.ol-scale {\r\n  left: auto !important;\r\n  right: 0.5em;\r\n  transform: none !important;\r\n  /* bottom: 3.5em !important; */\r\n\r\n  input {\r\n    width: 84px !important;\r\n    font-size: 11px;\r\n  }\r\n}\r\n\r\n#laman.layerManagerMain {\r\n  position: fixed;\r\n  z-index: 1;\r\n  width: 375px;\r\n  display: block;\r\n  top: 0;\r\n  left: 0;\r\n  bottom: 0;\r\n  opacity: 0.8;\r\n  box-shadow: 6px 0 16px -8px rgba(0, 0, 0, 0.08), 9px 0 28px 0 rgba(0, 0, 0, 0.05),\r\n    12px 0 48px 16px rgba(0, 0, 0, 0.03);\r\n  transition: transform 0.3s ease;\r\n  /* Panelin kayarak açılıp kapanması için animasyon */\r\n\r\n  .layerManagerCards {\r\n    height: 100%;\r\n\r\n    .projectName {\r\n      text-align: justify;\r\n      font-size: 14px;\r\n    }\r\n\r\n    .ant-table-pagination.ant-pagination {\r\n      align-items: center;\r\n      justify-content: center;\r\n    }\r\n\r\n    .ant-card-head .ant-card-head-title {\r\n      font-weight: 450;\r\n      text-align: center;\r\n    }\r\n\r\n    .ant-card-body {\r\n      padding: 0 !important;\r\n      height: 100%;\r\n    }\r\n\r\n    .ant-tabs-nav {\r\n      margin: 0;\r\n\r\n      .ant-tabs-tab-btn span svg {\r\n        padding-right: 5px;\r\n      }\r\n    }\r\n\r\n    .ninjadash-tab-white .ant-tabs-content {\r\n      padding: 0;\r\n    }\r\n\r\n    .user-info {\r\n      border-bottom: 1px solid rgb(241, 242, 246);\r\n      padding: 10px;\r\n      margin: 0;\r\n\r\n      .buttonArea {\r\n        display: flex;\r\n        gap: 10px;\r\n        justify-content: space-between;\r\n      }\r\n\r\n      button {\r\n        flex: 1;\r\n      }\r\n    }\r\n\r\n    .user-info__title {\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: space-between;\r\n\r\n      .add-work {\r\n        margin-right: 10px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 767px) {\r\n  /* Mobil panel davranışı */\r\n  #laman.layerManagerMain {\r\n    position: fixed !important;\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n    top: auto !important;\r\n    width: 100% !important;\r\n    height: 75vh !important;\r\n    max-height: 75vh !important;\r\n    z-index: 999;\r\n    background: white;\r\n    transform: translateY(0%);\r\n    border-top-left-radius: 12px;\r\n    border-top-right-radius: 12px;\r\n    box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.15);\r\n    overflow: hidden;\r\n    transition: transform 0.3s ease;\r\n  }\r\n\r\n  #laman.layerManagerMain.closed {\r\n    transform: translateY(100%) !important;\r\n  }\r\n\r\n  /* Panel içeriği */\r\n  .layerManagerCards .ant-card-body {\r\n    flex-grow: 1;\r\n    overflow-y: auto;\r\n    padding: 12px;\r\n  }\r\n\r\n  .layerManagerTitle {\r\n    font-size: 13px;\r\n    text-align: center;\r\n    padding: 0 12px;\r\n    word-break: break-word;\r\n  }\r\n\r\n  .projectName {\r\n    font-size: 12.5px;\r\n    text-align: center;\r\n    color: #666;\r\n    padding: 0 12px;\r\n  }\r\n\r\n  .settings-menmulist ul {\r\n    padding: 0;\r\n    margin: 0;\r\n    list-style: none;\r\n  }\r\n\r\n  .settings-menmulist ul li a {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n    padding: 10px 12px;\r\n    font-size: 14px;\r\n    color: #333;\r\n    border-radius: 6px;\r\n  }\r\n\r\n  .settings-menmulist ul li a:hover {\r\n    background: #f5f5f5;\r\n  }\r\n\r\n  .settings-menmulist ul li a svg {\r\n    width: 18px;\r\n    height: 18px;\r\n    flex-shrink: 0;\r\n  }\r\n\r\n  .settings-menmulist ul li a span {\r\n    word-break: break-word;\r\n  }\r\n}\r\n\r\n.table-header-align-center .ant-table-thead > tr > th {\r\n  text-align: center;\r\n}\r\n\r\n.ol-popup {\r\n  position: absolute;\r\n  background: #fff;\r\n  border-radius: 8px;\r\n  border: 1px solid #d0d5dd;\r\n  box-shadow: 0 8px 24px rgba(16, 24, 40, 0.12);\r\n  padding: 12px 14px;\r\n  min-width: 260px;\r\n  transform: translate(-50%, -100%);\r\n  pointer-events: auto;\r\n  z-index: 1000;\r\n}\r\n.ol-popup-closer {\r\n  position: absolute;\r\n  top: 6px;\r\n  right: 8px;\r\n  text-decoration: none;\r\n  color: #667085;\r\n  font-size: 18px;\r\n  line-height: 14px;\r\n}\r\n.ol-popup table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  font-size: 12px;\r\n}\r\n.ol-popup td {\r\n  padding: 4px 0;\r\n  vertical-align: top;\r\n}\r\n.ol-popup td:first-child {\r\n  font-weight: 600;\r\n  color: #344054;\r\n  width: 38%;\r\n  padding-right: 8px;\r\n}\r\n\r\n.ol-tooltip {\r\n  position: absolute;\r\n  background: transparent;\r\n  pointer-events: none;\r\n  z-index: 1000;\r\n  white-space: nowrap;\r\n}\r\n\r\n.ant-collapse.calismaCollapse {\r\n  border-radius: 0;\r\n\r\n  .ant-collapse-extra {\r\n    height: 23.56px;\r\n    color: dimgrey;\r\n  }\r\n\r\n  .genExtra {\r\n    display: flex;\r\n    align-items: center;\r\n\r\n    .ant-divider-vertical {\r\n      margin: 0 1px;\r\n    }\r\n  }\r\n\r\n  .ant-collapse-content {\r\n    .ant-collapse-content-box {\r\n      padding: 0;\r\n    }\r\n  }\r\n\r\n  .ant-collapse-item {\r\n    border-radius: 0;\r\n\r\n    .ant-collapse-header {\r\n      padding: 5px 10px;\r\n    }\r\n  }\r\n\r\n  .ant-table-thead tr th,\r\n  .ant-table-tbody tr td,\r\n  .ant-table tfoot tr th,\r\n  .ant-table tfoot tr td {\r\n    padding: 2px 10px;\r\n  }\r\n}\r\n\r\n.ant-collapse.halihazirCollapse {\r\n  border-radius: 0;\r\n\r\n  .ant-collapse-extra {\r\n    height: 23.56px;\r\n    color: dimgrey;\r\n  }\r\n\r\n  .genExtra {\r\n    display: flex;\r\n    align-items: center;\r\n\r\n    .ant-divider-vertical {\r\n      margin: 0 1px;\r\n    }\r\n  }\r\n\r\n  .ant-collapse-content {\r\n    .ant-collapse-content-box {\r\n      padding: 5px;\r\n    }\r\n  }\r\n\r\n  .halihazirGroup .ant-collapse-content {\r\n    .ant-collapse-content-box {\r\n      padding: 0px;\r\n    }\r\n  }\r\n\r\n  .ant-collapse-item {\r\n    border-radius: 0;\r\n\r\n    .ant-collapse-header {\r\n      padding: 5px 10px;\r\n    }\r\n  }\r\n\r\n  .ant-table-thead tr th,\r\n  .ant-table-tbody tr td,\r\n  .ant-table tfoot tr th,\r\n  .ant-table tfoot tr td {\r\n    padding: 2px 10px;\r\n  }\r\n}\r\n\r\n.projeToolbar {\r\n  position: absolute;\r\n  z-index: 1;\r\n  display: block;\r\n  width: auto;\r\n  top: 23px;\r\n  left: 390px;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  gap: 10px;\r\n}\r\n\r\n.ant-card {\r\n  border-radius: 0;\r\n}\r\n\r\n.mouse-position {\r\n  position: absolute;\r\n  bottom: 2px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  background: rgba(255, 255, 255, 0.8);\r\n  padding: 5px;\r\n  /* border-radius: 3px; */\r\n  font-size: 12px;\r\n  z-index: 1000;\r\n\r\n  @media screen and (max-width: 767px) {\r\n    font-size: 10px;\r\n  }\r\n}\r\n\r\n.ant-menu-submenu-popup {\r\n  z-index: 1005 !important;\r\n}\r\n\r\n.label-center .ant-form-item-label {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  max-width: 76px;\r\n}\r\n\r\n.input-sm .ant-input-sm {\r\n  padding: 6.5px 20px;\r\n}\r\n\r\n.ant-input-number-group-wrapper {\r\n  width: 100%;\r\n}\r\n\r\n.mt-24 {\r\n  margin-top: 24px;\r\n}\r\n\r\n.center {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.layerManagerTitle {\r\n  font-weight: 450;\r\n  text-align: center;\r\n  margin: 0px;\r\n  margin-left: 8px;\r\n  font-size: 18px;\r\n  color: #0a0a0a;\r\n}\r\n\r\n.layerManagerHeaderLogo {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  border-bottom: #fafafa solid 2px;\r\n  padding: 10px 0;\r\n}\r\n\r\n.layerManagerHeaderLogoHeader {\r\n  display: flex;\r\n  justify-content: space-evenly;\r\n  align-items: center;\r\n  border-bottom: #fafafa solid 2px;\r\n  padding: 10px;\r\n}\r\n\r\n.yerbisLogo {\r\n  display: flex;\r\n  justify-content: center;\r\n  margin: 10px 0;\r\n}\r\n\r\n@media (max-width: 767px) {\r\n  #laman.layerManagerMain.closed {\r\n    transform: translateY(100%) !important;\r\n  }\r\n\r\n  #laman.layerManagerMain {\r\n    position: fixed !important;\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n    top: auto !important;\r\n    width: 100% !important;\r\n    height: 75vh !important;\r\n    max-height: 75vh !important;\r\n    z-index: 999;\r\n    background: white;\r\n    transform: translateY(0%);\r\n    border-top-left-radius: 12px;\r\n    border-top-right-radius: 12px;\r\n    box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.15);\r\n    overflow: hidden;\r\n    transition: transform 0.3s ease;\r\n    padding-top: 30px;\r\n  }\r\n\r\n  .mobile-panel-toggle {\r\n    position: fixed;\r\n    top: 10px;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n    width: 40px;\r\n    height: 21px !important;\r\n    background: rgba(200, 200, 200, 0.85);\r\n    border-radius: 0 20% 20% 0;\r\n    z-index: 1001;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);\r\n  }\r\n\r\n  .mobile-panel-toggle .arrow {\r\n    width: 0;\r\n    height: 0;\r\n    border-left: 7px solid transparent;\r\n    border-right: 7px solid transparent;\r\n    border-top: 7px solid #000;\r\n    transition: transform 0.3s ease;\r\n  }\r\n\r\n  .mobile-panel-toggle .arrow.down {\r\n    transform: rotate(180deg);\r\n  }\r\n\r\n  .ql-toolbar.ql-snow .ql-formats button {\r\n    width: 24px !important;\r\n    height: 24px !important;\r\n  }\r\n\r\n  .ql-toolbar.ql-snow .ql-formats svg {\r\n    width: 16px !important;\r\n    height: 16px !important;\r\n  }\r\n\r\n  .ql-toolbar.ql-snow {\r\n    padding: 4px !important;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
